import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Button, Collapse } from "antd";
import React, { useEffect } from "react";
import useForm from "../hooks/useForm";
import { GenericSelect } from "../components/select/GenericSelect";
import { sortByAlpha } from "../utils/filterUtils";
import { useAppContext } from "../context/useAppContext";
import { GenericInput } from "../components/input/GenericInput";
import { ImageWrapper } from "../components/image/ImageViewer";
import { FileUploader } from "../components/upload/FileUploader";

const FormItem = ({ data, updateItem, index }) => {
  const { contextData } = useAppContext();
  const { categories } = contextData;
  const { form, onChange, updateFormValues, setForm } = useForm(data);

  useEffect(() => {
    updateItem(form, index);
  }, [form]);

  useEffect(() => {
    if (data) setForm(data);
  }, [data]);

  return (
    <div className="flexColumn gap10">
      <GenericInput
        label="Title"
        value={form?.title}
        name="title"
        onChange={onChange}
        required
      />
      <GenericSelect
        label="Category"
        mode="multiple"
        value={form?.source}
        options={sortByAlpha(categories, "category_name")?.map((item) => {
          return {
            value: item.id,
            label: item.category_name,
          };
        })}
        onChange={(value) => {
          updateFormValues({ source: value });
        }}
        helperText="You can select multiple categories for recommendation."
        required
      />
      <div className="flex gap10">
        {/* Images */}
        <div className="x100">
          <FileUploader
            images={form?.images}
            setImages={(images) => updateFormValues({ images })}
            label="Banner Image"
            limit={1}
            required
          />
        </div>
        {/* Images */}
        {data?.url && <ImageWrapper images={[data?.url]} />}
      </div>
    </div>
  );
};

export const ExpandableBannerForm = ({
  title = "Banner Items",
  form,
  updateFormValues,
  field,
}) => {
  const items = form[field] || [{}];

  const addItem = () =>
    updateFormValues({ [field]: [...(form[field] || [{}]), {}] });

  const removeItem = (e, index) => {
    e.stopPropagation();

    const newItems = items.filter((_, i) => i !== index);
    updateFormValues({ [field]: newItems });
  };

  const updateItem = (data, index) => {
    const mainData = form[field];
    if (mainData?.length > 0) {
      mainData[index] = data;
      updateFormValues({ [field]: mainData });
    } else {
      updateFormValues({ [field]: [data] });
    }
  };

  return (
    <div className="flexColumn gap20">
      {/* HEADER */}
      <div className="flexSpaceCenter">
        <div className="bold">{title}</div>
        <Button type="primary" className="font12" onClick={addItem}>
          Add Item
        </Button>
      </div>
      {/* LIST */}
      <div className="flexColumn gap10">
        {/* ITEMS */}
        {items?.map((item, i) => (
          <Collapse
            size="small"
            items={[
              {
                key: i,
                label:
                  (item?.title && `${i + 1}. ${item?.title}`) ||
                  `${i + 1}. Banner Image `,
                extra: i > 0 && (
                  <IconButton size="small" onClick={(e) => removeItem(e, i)}>
                    <Close sx={{ fontSize: 15 }} />
                  </IconButton>
                ),
                children: (
                  <FormItem data={item} updateItem={updateItem} index={i} />
                ),
              },
            ]}
          />
        ))}
      </div>
    </div>
  );
};
